import { type FormEvent, useState } from 'react'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router'

import { useLogin } from '@/api/auth'
import { strings } from '@/lib/strings'

import { AuthForm, Field } from './AuthForm'
import { OAuthButtons } from './OAuthButtons'
import { authErrorMessage, oauthErrorMessage } from './errorMessage'
import { redirectTarget } from './redirect'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const mutation = useLogin()
  // Сюда возвращает неудачный колбэк провайдера: причина приходит кодом
  // в адресе, потому что редирект тела ответа не несёт.
  const oauthError = oauthErrorMessage(searchParams.get('auth_error'))
  const target = redirectTarget(location.state)

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    mutation.mutate(
      { email, password },
      {
        onSuccess: () => {
          // Возврат туда, откуда пользователя увели на вход: иначе он теряет
          // задачу, которую открывал.
          void navigate(target, { replace: true })
        },
      },
    )
  }

  return (
    <AuthForm
      title={strings.auth.loginTitle}
      submitLabel={strings.auth.submitLogin}
      pending={mutation.isPending}
      error={authErrorMessage(mutation.error) ?? oauthError}
      onSubmit={handleSubmit}
      aside={<OAuthButtons next={target} />}
      footer={
        <>
          {strings.auth.noAccount}{' '}
          <Link to="/register" className="text-accent">
            {strings.auth.goToRegister}
          </Link>
        </>
      }
    >
      <Field
        id="email"
        label={strings.auth.email}
        type="email"
        value={email}
        autoComplete="email"
        required
        onChange={setEmail}
      />
      <Field
        id="password"
        label={strings.auth.password}
        type="password"
        value={password}
        autoComplete="current-password"
        required
        onChange={setPassword}
      />
    </AuthForm>
  )
}
